"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSubscriptionItemInput = instanceOfSubscriptionItemInput;
exports.SubscriptionItemInputFromJSON = SubscriptionItemInputFromJSON;
exports.SubscriptionItemInputFromJSONTyped = SubscriptionItemInputFromJSONTyped;
exports.SubscriptionItemInputToJSON = SubscriptionItemInputToJSON;
/**
 * Check if a given object implements the SubscriptionItemInput interface.
 */
function instanceOfSubscriptionItemInput(value) {
    if (!('payment_level' in value) || value['payment_level'] === undefined)
        return false;
    if (!('quantity' in value) || value['quantity'] === undefined)
        return false;
    if (!('trial_until' in value) || value['trial_until'] === undefined)
        return false;
    return true;
}
function SubscriptionItemInputFromJSON(json) {
    return SubscriptionItemInputFromJSONTyped(json, false);
}
function SubscriptionItemInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'payment_level': json['payment_level'],
        'quantity': json['quantity'],
        'trial_until': json['trial_until'],
    };
}
function SubscriptionItemInputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'payment_level': value['payment_level'],
        'quantity': value['quantity'],
        'trial_until': value['trial_until'],
    };
}
